import type { AxiosError } from 'axios';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import { getTokens, INTEGRATION_TOKENS_QUERY_KEY } from '../domains/api';

type GetTokens = typeof getTokens;
type ApiResponseType = Awaited<ReturnType<GetTokens>>;

export function useIntegrationTokens(
  siteId: string | null,
): UseQueryResult<ApiResponseType, AxiosError> {
  return useQuery<ApiResponseType, AxiosError>(
    [INTEGRATION_TOKENS_QUERY_KEY, siteId],
    () => getTokens(siteId as string),
    {
      enabled: siteId !== null,
      staleTime: 5 * 60 * 1000, // 5 minutes.
    },
  );
}
